import { Box, FormControl } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import React, { memo, useEffect, useState } from 'react'
import Delete from '@mui/icons-material/Delete'
import AddIcon from "@mui/icons-material/Add";
import { generateRandomID } from 'helpers/generateRandomID'
import { FormOneCustomerNameRuleEdit } from './FormOneCustomerNameRuleEdit';
import { getCustomersCoincidences } from './GetCustomerCoincidences';
import { useSearch } from 'hooks/useSearch';

export const FormCustomerNameRuleEdit = memo((props) => {
  const { setRulesKeys, setRules, rulesKeys, rules, rule, idStation } = props.ruleHandlers
  const { setSnackbar } = useSearch();
  const [names, setNames] = useState([]) //AGREGAR LOS NOMBRES CUANDO LA REGLA YA VIENE DE UN CONTRATO SELECCIONADO
  const [validatedNames, setValidatedNames] = useState([])
  useEffect(() => {
    if(rule.ruleKeys) {
      rule.ruleKeys.forEach(async(ruleKey) => {
        const newName = ruleKey?.value.split('%');
        let options = await getCustomersCoincidences(newName[0], idStation, setSnackbar)
        if(options && options.length) options = options.map(customer => {
          const address = customer?.address ? customer?.address : {}
          const calle = address?.street ? ` -c: ${address?.street}` : ''
          const colonia = address?.colony ? ` -col: ${address?.colony}` : ''
          const codigoPostal = address?.postalCode ? ` -cp: ${address?.postalCode}` : ''
          return {
            ...customer, 
            value: customer.id, 
            label: `${customer.name}${calle}${colonia}${codigoPostal}`
          }
        })
        setValidatedNames([...validatedNames, {name: newName[0], options}])
        let selectedClients = newName[1].split(',')
        selectedClients = options.filter(option => selectedClients.includes(option.id))
        if(selectedClients.length === options.length) selectedClients = [{id: '1234', value: 'all', label: 'Todos los resultados'}, ...selectedClients]
        setNames([...names, {
          id: generateRandomID(32), 
          name: newName[0], 
          isBad: false, 
          options, 
          selectedClients 
        }])
      })
    }
  }, [rule?.ruleKeys])

  useEffect(() => {
    let valueString = ''
    names.every(item => {
      if(item.name && !item.isBad && item.selectedClients.length) {
        const idsString = item.selectedClients
          .filter(customer => customer.value !== 'all')
          .map(customer => customer.id)
          .toString()
        valueString = valueString + item.name.toUpperCase() + '%' + idsString + '#'
        return true
      } else {
        valueString = ''
        return false
      }
    })
    if(valueString.length > 0) {
      valueString = valueString.slice(0,valueString.length - 1)
      setRulesKeys([...rulesKeys.filter(item => item.idRule !== rule.id),{idRule: rule.id, idRuleKey: valueString}])
      setRules(rules.map(item => {
        if (item.id === rule.id) return {...rule, isComplete: 'good'}
        else return item
      }))
    } else {
      setRules(rules.map(item => {
        if (item.id === rule.id) return {...rule, isComplete: 'bad'}
        else return item
      }))
      setRulesKeys([...rulesKeys.filter(item => item.idRule !== rule.id)])
    }
  }, [names])

  useEffect(() => {
    setNames([{id: generateRandomID(32), name: '', isBad: false, options: [], selectedClients: []}])
  }, [idStation])
  
  return (
    <>
      <Box style={{display: 'flex', justifyContent: 'space-between', marginTop: 30, width: '98%'}}>
        <Typography style={{ alignSelf: 'center' }}>Agregar Cliente</Typography>
        <RegularButton 
          round 
          justIcon 
          color="info" 
          style={{ margin: 10 }} 
          onClick={() => setNames([...names, {
            id: generateRandomID(32), 
            name: '',
            isBad: false,
            options: [],
            selectedClients: []
          }])}
        >
          <AddIcon style={{ margin: 0 }}/>
        </RegularButton>
      </Box>
      {
        names.map(name => (
          <FormControl key={name.id} style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            gap: 10, 
            marginTop: 20, 
            alignItems: 'center', 
            flexDirection: 'row', 
            width: '90%'
          }}>
            <FormControl style={{display: 'flex', justifyContent: 'space.between', gap: 10, flexDirection: 'row', flexGrow: 1}} variant="outlined">
              <FormOneCustomerNameRuleEdit 
                key={name.id} 
                name={name} 
                names={names} 
                setNames={setNames}
                validatedNames={validatedNames}
                setValidatedNames={setValidatedNames}
                idStation={idStation}
              />
            </FormControl>
            <RegularButton 
              round 
              justIcon 
              color={"danger"} 
              style={{ margin: 0 }}
              disabled={names.length === 1} 
              onClick={(e) => {
                e.stopPropagation()
                setNames(names.filter(item => item.id !== name.id))
              }}
            >
              <Delete style={{ margin: 0 }}/>
            </RegularButton>
          </FormControl>
        ))
      }
    </>
  )
})
